import React from 'react';
import {
  ServicesBentoGrid,
  ServicesDetailSection,
  ProposalEstimatorWidget
} from '../components/sections';

export const ServicesPage: React.FC<{ onOpenConsultation: () => void }> = ({ onOpenConsultation }) => {
  return (
    <div className="pt-20">
      <ServicesBentoGrid onSelectService={() => onOpenConsultation()} />
      <ServicesDetailSection onOpenConsultation={onOpenConsultation} />
      <ProposalEstimatorWidget />
    </div>
  );
};
